import { Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    standalone: true,
    selector: 'app-loading-backdrop',
    imports: [
        MatProgressSpinnerModule,
    ],
    templateUrl: './loading-backdrop.component.html',
    styleUrl: './loading-backdrop.component.css'
})
export class LoadingBackdropComponent {
  color = 'primary';
  mode = 'determinate';
  value = 50;

  @Input() text: string = "";
}
